import { useImageryFlags } from '@hooks/useImageryFlags';
import actions from '@redux/imageAssets/actions';
import { loadAssetsAndImages } from '@redux/imageAssets/thunks';
import type { RootState } from '@redux/reducers';
import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useS2BImageExclusion = (propertyId?: string) => {
  const { FlagShowS2BAlert } = useImageryFlags();
  const dispatch = useDispatch();
  const exclusionEnabled = useSelector(
    (state: RootState) => state.ImageAsset.s2bImageExclusionEnabled
  );
  const catalogStatus = useSelector((state: RootState) => state.ImageAsset.status);

  // Keep non-React catalog loaders in sync before descendants start loading imagery.
  useLayoutEffect(() => {
    if (exclusionEnabled === FlagShowS2BAlert) return;

    dispatch(actions.setS2BImageExclusionEnabled(FlagShowS2BAlert));

    // In-flight loads read the latest flag after receiving the response. A completed
    // catalog must be fetched again so switching the flag off also restores its images.
    if (propertyId && catalogStatus === 'success') {
      dispatch(loadAssetsAndImages(propertyId));
    }
  }, [FlagShowS2BAlert, exclusionEnabled, catalogStatus, dispatch, propertyId]);
};
